export const InteractionTextSelection = `
<div>
  <p className="user-select-all">
    This paragraph will be entirely selected when clicked by the user.
  </p>
  <p className="user-select-auto">This paragraph has default select behavior.</p>
  <p className="user-select-none">
    This paragraph will not be selectable when clicked by the user.
  </p>
</div>
`
